import React,{ useState, useEffect } from "react";
import { 
    Button,
    Form,
    Input 
} from 'antd';
import axios from 'axios';

import { 
    LaptopOutlined
} from '@ant-design/icons';

function ServiceAddress( { 
    qualifiedAddress,
    cartHasItems,
    currentStep,
    setProgressCount,
    setServiceAddressComponentCompleted,
    contactInfoComponentCompleted,
    paymentReceived,
    shippingAddress,
    setShippingAddress,
    shippingAddressUnit,
    setShippingAddressUnit,
    billingAddress,
    setBillingAddress,
    billingAddressUnit,
    setBillingAddressUnit,
    internetServiceInCart
    } ) {

    const [shippingCompleted, setShippingCompleted] = useState(true);
    const [billingCompleted, setBillingCompleted] = useState(true);
    const [shippingChangeDisplay, setShippingChangeDisplay] = useState('block');
    const [billingChangeDisplay, setBillingChangeDisplay] = useState('block');
    const [shippingAddressSuggestionList, setShippingAddressSuggestionList] = useState(<></>);
    const [billingAddressSuggestionList, setBillingAddressSuggestionList] = useState(<></>);
    
    const [showNextStep, setShowNextStep] = useState( 'block' );
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;

    useEffect(() => {
        let shippingAddressToUse = ( headerVars.shippingAddress != '' ) ? headerVars.shippingAddress : qualifiedAddress;
        setShippingAddress( shippingAddressToUse );

        let billingAddressToUse = ( headerVars.billingAddress != '' ) ? headerVars.billingAddress : qualifiedAddress;
        setBillingAddress( billingAddressToUse );

        //console.log('internetServiceInCart: ', internetServiceInCart);
        //console.log('contactInfoComponentCompleted: ', contactInfoComponentCompleted);

        if( cartHasItems && contactInfoComponentCompleted) {
            if( headerVars.billingAddress != '' && headerVars.shippingAddress != '' ) {
                setProgressCount(2);
                setShowNextStep( 'none' );
                setServiceAddressComponentCompleted(true);
            } else {
                setProgressCount(1);
                setShowNextStep( 'block' );
            }
            
        } else {
            //setProgressCount(2);
            setShowNextStep( 'none' );
        }
    },[cartHasItems, contactInfoComponentCompleted])

    const handleChangeContactInfo = ( e ) => {
        //setComponentCompleted( false );
        let checkAvailabilityBtn = jQuery(".check-availability-btn .elementor-button, .internet-package-check-availability-button");
        let checkAvailabilityOverlay = jQuery(".modal-overlay");
        let addressInput = jQuery("#check-availability-modal-address-input");

        checkAvailabilityOverlay.toggleClass("active");
        addressInput.focus();
    }

    const getDisplayOption = () => {
        //console.log( 'cartHasItems:: ', cartHasItems );
        //console.log( 'qualifiedAddress:: ', qualifiedAddress );
        //console.log( 'currentStep:: ', currentStep );

        if( cartHasItems && currentStep >= 1 ) {
            return 'block'
        } else {
            return 'none'
        }
    }

    const handleChangeShippingAddress = () => {
        setShippingCompleted( false );
        setShippingAddress( '' );
        setServiceAddressComponentCompleted(false);
        setProgressCount(1);
        setShippingChangeDisplay( 'none' );
        setShowNextStep( 'block' );
        form.setFieldsValue({ "shipping-address": ''});
    }

    const handleChangeBillingAddress = () => {
        setBillingCompleted( false );
        setBillingAddress( '' );
        setServiceAddressComponentCompleted(false);
        setProgressCount(1);
        setBillingChangeDisplay( 'none' );
        setShowNextStep( 'block' );
        form.setFieldsValue({ "billing-address": ''});
    }

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        let form_data = new FormData;
        form_data.append('headers', {"Authorization": "Bearer "+headerVars.startAPIKey});

        if( currentVal.length > 6 ) {
            axios
            .get(headerVars.startAPIAddress+"/address/validate_telus?fullAddress="+currentVal, {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
            .then(function(response){
                let suggestions = response.data.body.suggestions;
                //console.log('suggestions: ', suggestions);

                if(suggestions.length){
                    if( inputID == 'shipping-address-input' ) {
                        listAddressSugestions(suggestions, 'shipping'); 
                    } 

                    if( inputID == 'billing-address-input' ) {
                        listAddressSugestions(suggestions, 'billing'); 
                    }
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }
    }

    const listAddressSugestions = ( suggestions, lookupType ) => {
        let suggestionListItems = suggestions.map( suggestion => {
            let suggestionText = suggestion.text.replace(', CAN', '');
            return(
                <li id={suggestion.magicKey} className='address-suggestion-item' onClick={() => handleSuggestionClick( suggestionText, lookupType ) }>
                    { suggestionText + ". " }
                </li>
            );
        } );

        if( lookupType == 'shipping' ) {
            setShippingAddressSuggestionList( <ul>{ suggestionListItems }</ul> );
        }

        if( lookupType == 'billing' ) {
            setBillingAddressSuggestionList( <ul>{ suggestionListItems }</ul> );
        }
    }

    const handleSuggestionClick = ( suggestionText, lookupType ) => {
        //console.log("suggestionText:: ", suggestionText);

        if( lookupType == 'shipping' ) {
            setShippingAddress( suggestionText );
            setShippingAddressSuggestionList(<></>);
            form.setFieldsValue({ "shipping-address": suggestionText});
        }

        if( lookupType == 'billing' ) {
            setBillingAddress( suggestionText );
            setBillingAddressSuggestionList(<></>);
            form.setFieldsValue({ "billing-address": suggestionText});
        }
    }

    const handleOnAddressUnitChange = ( e ) =>{
        let currentVal = e.target.value;
        let inputID = e.target.id;

        switch( inputID ) {
            case 'shipping-address-unit-input':
            setShippingAddressUnit( currentVal );
            break;

            case 'billing-address-unit-input':
            setBillingAddressUnit( currentVal );
            break;
        }
    }

    const handleConfirmChangeShippingAddress = () =>{
        setShippingCompleted( true );
    }

    const handleConfirmChangeBillingAddress = () =>{
        setBillingCompleted( true );
    }

    const getShippingMarkup = () => {
        if( shippingCompleted ) {
            let shippingAddressWithUnit = ( shippingAddressUnit != '' ) ? shippingAddress + ' Unit ' + shippingAddressUnit : shippingAddress;
            return (
                <div className="qualified-address-row">{ shippingAddressWithUnit }</div>
            )
        } else {
            return (
                <Form
                    form={ form }
                >
                    <div className="form-column-row inline">
                        <Form.Item
                            label="Shipping address"
                            labelCol={{ span: 24 }}
                            name="shipping-address"
                            style={{marginBottom:'0', width:'100%'}}
                            rules={[
                                {
                                required: true,
                                message: 'Please input your shipping address!',
                                },
                            ]}
                        >
                            <Input
                                id="shipping-address-input"
                                name="shipping-address-input"
                                onChange={handleOnInputChange}
                                autoFocus
                                defaultValue={ shippingAddress }
                            />
                        </Form.Item>

                        <Form.Item
                            label="Unit"
                            labelCol={{ span: 24 }}
                            name="shipping-address-unit-input"
                            style={{marginBottom:'0', width:'20%', paddingLeft: '1rem'}}
                        >
                            <Input
                                id="shipping-address-unit-input"
                                name="shipping-address-unit-input"
                                onChange={handleOnAddressUnitChange}
                                defaultValue={ '' }
                            />
                        </Form.Item>
                        <Form.Item
                            label=" "
                            labelCol={{ span: 24 }}
                            name="shipping-address-apply-button"
                            style={{marginBottom:'0', width:'20%', paddingLeft: '1rem'}}
                        >
                            <Button 
                                type="default"
                                class=""
                                disabled={( shippingAddress != '' ) ? false : true } 
                                onClick={ handleConfirmChangeShippingAddress }>
                                Apply
                            </Button>
                        </Form.Item>
                        
                    </div>
                    <div className="suggestion-list-container">
                        { shippingAddressSuggestionList }
                    </div>
                </Form>
            )
        }
    }

    const getBillingMarkup = () => {
        if( billingCompleted ) {
            let billingAddressWithUnit = ( billingAddressUnit != '' ) ? billingAddress + ' Unit ' + billingAddressUnit : billingAddress;
            return (
                <div className="qualified-address-row">{ billingAddressWithUnit }</div>
            )
        } else {
            return (
                <Form
                    form={ form }
                >
                    <div className="form-column-row inline">
                        <Form.Item
                            label="Billing address"
                            labelCol={{ span: 24 }}
                            name="billing-address"
                            style={{marginBottom:'0', width:'100%'}}
                            rules={[
                                {
                                required: true,
                                message: 'Please input your billing address!',
                                },
                            ]}
                        >
                            <Input
                                id="billing-address-input"
                                name="billing-address-input"
                                onChange={handleOnInputChange}
                                autoFocus
                                defaultValue={ billingAddress }
                            />
                        </Form.Item>

                        <Form.Item
                            label="Unit"
                            labelCol={{ span: 24 }}
                            name="billing-address-unit-input"
                            style={{marginBottom:'0', width:'20%', paddingLeft: '1rem'}}
                        >
                            <Input
                                id="billing-address-unit-input"
                                name="billing-address-unit-input"
                                onChange={handleOnAddressUnitChange}
                                defaultValue={ '' }
                            />
                        </Form.Item>

                        <Form.Item
                            label=" "
                            labelCol={{ span: 24 }}
                            name="billing-address-apply-button"
                            style={{marginBottom:'0', width:'20%', paddingLeft: '1rem'}}
                        >
                            <Button 
                                type="default"
                                class=""
                                disabled={( billingAddress != '' ) ? false : true } 
                                onClick={ handleConfirmChangeBillingAddress }>
                                Apply
                            </Button>
                        </Form.Item>
                    </div>
                    <div className="suggestion-list-container">
                        { billingAddressSuggestionList }
                    </div>
                </Form>
            )
        }
    }

    const handleOnNextStepClick = ( e ) => {
        setServiceAddressComponentCompleted(true);
        setShowNextStep( 'none' );
        setProgressCount(2);
        
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        let form_data = new FormData;
        let billingAddressWithUnit = ( billingAddressUnit != '' ) ? billingAddress + ' Unit ' + billingAddressUnit : billingAddress;
        let shippingAddressWithUnit = ( shippingAddressUnit != '' ) ? shippingAddress + ' Unit ' + shippingAddressUnit : shippingAddress;

        form_data.append( 'action', 'store_shipping_info_in_session' );
        form_data.append( 'shipping_address', shippingAddressWithUnit );
        form_data.append( 'billing_address', billingAddressWithUnit );
        form_data.append( 'qualified_address', qualifiedAddress );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            //console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            // always executed 
        }); 
    }

    return ( 
        <div className="configuration-container config-section-container" style={{ display: ( internetServiceInCart ) ? 'block' : 'none' }}>
            <div className="contact-info-folded">
                <hr />
                
                <div className="configuration-header-container">
                    <div className="configuration-header">
                        Service address
                    </div>
                    
                    <div className="component-update-link" style={{"display": 'none'/*getDisplayOption()*/}}>
                        <Button 
                            type="link" 
                            class="change-info-button internet-package-check-availability-button"
                            style={ { display: paymentReceived ? 'none' : 'block' } }
                            onClick={ handleChangeContactInfo }>Change</Button>
                    </div>
                </div>

                <div className="" style={{"display": getDisplayOption()}}>
                    <div 
                        className="qualified-address-row" 
                        style={{"display": getDisplayOption()}}
                    >
                        { qualifiedAddress }
                    </div>

                    <div 
                        className="shipping-address-container" 
                        style={{"display": getDisplayOption()}}
                    >
                        <div className="shipping-address-header-container">
                            <div className="shipping-address-header">Shipping address</div>
                            <div 
                                className="component-update-link" 
                                style={{"display": shippingCompleted ? 'block' : 'none'}}>
                                
                                <Button 
                                    type="link" 
                                    class="change-shipping-address-button"
                                    style={ { display: paymentReceived ? 'none' : 'block' } }
                                    onClick={ handleChangeShippingAddress }>
                                    Change
                                </Button>
                            </div>
                        </div>
                        { getShippingMarkup() }
                    </div>

                    <div 
                        className="shipping-address-container" 
                        style={{"display": getDisplayOption()}}
                    >
                        <div className="shipping-address-header-container">
                            <div className="shipping-address-header">Billing address</div>
                            <div 
                                className="component-update-link" 
                                style={{"display": billingCompleted ? 'block' : 'none' }}>
                                
                                <Button 
                                    type="link"
                                    class="change-shipping-address-button" 
                                    style={ { display: paymentReceived ? 'none' : 'block' } }
                                    onClick={ handleChangeBillingAddress }>
                                    Change
                                </Button>
                            </div>
                        </div>
                        { getBillingMarkup() }
                    </div>
                    <Button 
                        onClick={ handleOnNextStepClick } 
                        disabled={ ( shippingAddress.length > 10 && billingAddress.length > 10 ) ? false : true }
                        style={ { "margin":'1rem 0', "display":showNextStep } }
                    >Next Step</Button>
                </div>
            </div>
        </div>
    )
}

export default ServiceAddress